import { useAtom } from 'jotai';

import { useGetApiV1SsoimageCategories } from '@/shared/api/generated';
import type { SlideCategory } from '../store/atoms/slideCategoriesAtom';
import { slideCategoriesAtom } from '../store/atoms/slideCategoriesAtom';

/**
 * Hook para gerenciar categorias da biblioteca de slides.
 * Encapsula CRUD de categorias e sincronização de slides órfãos.
 *
 * @returns Categorias e operações de criação, renomeação e exclusão.
 */
export function useSlideCategories() {
  const [categories, setCategories] = useAtom(slideCategoriesAtom);

  const { data: categoriesResponse } = useGetApiV1SsoimageCategories() as {
    data: SlideCategory[];
  };

  if (categoriesResponse) {
    setCategories(categoriesResponse);
  }

  return { categories } as const;
}
